// extracted by mini-css-extract-plugin
module.exports = {"PageGlobal":"PageGlobal","PageGlobal__section":"PageGlobal__section"};